<template>
  <div class="dropdown-button">
    <button id="user-dropdown-launcher"
            role="menuitem"
            aria-haspopup="true"
            aria-controls="app-bar-account-menu"
            :aria-expanded="showUserDropdown"
            class="app-bar-button"
            @click="showUserDropdown = true"
            v-t:title="'Account'">
      <avatar-image :user="user" width="20" height="20" />
    </button>
    <div v-if="showUserDropdown" class="dropdown-menu">
      <div class="dropdown dropdown-with-curtain user-dropdown" @click.self="cancel">
        <div id="app-bar-account-menu"
             role="menu"
             class="dropdown-content tv"
             :data-premium="isPremium">
          <div class="tv-section-divider app-bar-account-summary">
            <avatar-image :user="user" width="40" height="40" />
            <div class="strong-type">{{ displayName }}</div>
            <div class="small-type caption-type">{{ user.username }}</div>
            <template v-if="showQuota">
              <div class="quota-text small-type">{{ quotaUsageText }}</div>
              <progress-determinate class="quota-progress" :progress="quotaUsed" />
              <div class="quota-actions">
                <a role="button"
                   class="buttony-caption-type"
                   :style="{ visibility: showReferrals ? 'visible':'hidden' }"
                   href="/dashboard/settings/referrals"
                   data-app-target="blank"
                   v-t>Earn more</a>
                <a role="button"
                   class="buttony-type"
                   href="/premium/upgrade"
                   data-app-target="browser"
                   v-t>Upgrade</a>
              </div>
            </template>
          </div>
          <div class="tv tv-list">
            <a role="menuitem"
               class="tv-cell tv-cell-default tv-cell-actionable"
               href="/"
               data-app-target="self">
              <base-icon name="home" />
              <div v-t>Home</div>
            </a>
            <a role="menuitem"
               class="tv-cell tv-cell-default tv-cell-actionable"
               :href="profileUrl"
               data-app-target="blank">
              <base-icon name="profile" />
              <div v-t>Profile</div>
            </a>
            <a role="menuitem"
               class="tv-cell tv-cell-default tv-cell-actionable"
               href="/dashboard/drive"
               data-app-target="blank">
              <base-icon name="folder" />
              <div v-t>Drive</div>
            </a>
            <a role="menuitem"
               class="tv-cell tv-cell-default tv-cell-actionable"
               href="/dashboard/stats"
               data-app-target="blank">
              <base-icon name="stats" />
              <div v-t>Stats</div>
            </a>
            <a role="menuitem"
               class="tv-cell tv-cell-default tv-cell-actionable"
               href="/dashboard/settings"
               data-app-target="blank">
              <base-icon name="settings" />
              <div v-t>Settings</div>
            </a>
            <a v-if="isNotNativeTenant"
               role="menuitem"
               class="tv-cell tv-cell-default tv-cell-actionable"
               href="/org/import"
               data-app-target="blank">
              <base-icon name="download" />
              <div v-t>Import</div>
            </a>
          </div>
          <!-- <% unless other_logged_in_users.empty? -%>
            <div class="tv-section-divider small-caption-type" v-t>Switch account</div>
            <div class="tv tv-list">
              <% other_logged_in_users.each do |user| %>
              <a class="tv-cell tv-cell-subtitle tv-cell-actionable" href="<%= Loki.canonical_host_protocol %>://<%= user.tenant.domain_name %>">
                <%= avatar_tag user, width: 24, height: 24, role: "presentation" %>
                <div>
                  <div><%= user.display_name %></div>
                  <div class="small-caption-type"><%= user.tenant.name %></div>
                </div>
              </a>
              <% end %>
            </div>
          <% end -%> -->
          <div class="tv-section-divider" />
          <div class="tv">
            <form role="menuitem" method="post" action="/auth/logout">
              <csrf-input />
              <button class="raised-button block-button" type="submit" v-t>Log out</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IntlMixin from 'vuemixins/intl_mixin'
import AvatarImage from 'vuecomponents/avatar_image'
import BaseIcon from 'vuecomponents/base_icon'
import ProgressDeterminate from 'vuecomponents/progress_determinate'
import CsrfInput from 'vuecomponents/csrf_input'
import EscapeToCancelMixin from 'vuemixins/escape_to_cancel_mixin'

export default {
  components: {
    AvatarImage, BaseIcon, CsrfInput, ProgressDeterminate
  },
  mixins: [IntlMixin, EscapeToCancelMixin],
  props: ['user'],
  data: function () {
    return {
      showUserDropdown: false
    }
  },
  computed: {
    isUserRegistered: function () {
      return !!this.user.registered_at
    },
    showReferrals: function () {
      return this.isUserRegistered
    },
    displayName: function () {
      return this.user.name || this.user.username
    },
    profileUrl: function () {
      return `/${this.user.username}`
    },
    isPremium () {
      return this.user.paying
    },
    showQuota: function () {
      return !this.isPremium
    },
    quotaUsed: function () {
      return this.user.quota.walls_used / this.user.quota.walls_limit
    },
    quotaUsageText: function () {
      return this.__('%{num} of %{limit} padlets used', { num: this.user.quota.walls_used, limit: this.user.quota.walls_limit })
    },
    isNotNativeTenant: function () {
      return this.user.tenant_id !== 1
    }
  },
  methods: {
    cancel () {
      this.showUserDropdown = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./../../assets/stylesheets/3/modules/all";
.app-bar-account-summary {
  padding: 24px 16px 16px;
  background-color: transparent;
}
.dropdown-content {
  font-size: 16px;
  background-color: $default-background-color;
  @include standard-scheme;
}
.tv-list {
  background: white;
}
form {
  padding: 8px;
}
.quota-progress {
  background-color: $grey-4;
}
.quota-text {
  margin-top: 16px;
  margin-bottom: 8px;
}
.quota-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0 0;
}
[data-premium] .app-bar-account-summary {
  background-position: bottom -12px center;
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-image: url("../images/landing_rocket.svg")
}
</style>
